import { AnyAction } from 'redux';
import { GlobalActions } from '@ps20-frontend/shop-integration-redux';
import { App, PhVorbelegungdaten } from '@ps20-frontend/frontend-models';
import { PhActions } from '../phActions';

export const WOHNUNGSHAFTPFLICHT_NAME = 'HPVermietung19';
export const DEFAULT_ANZAHL_WOHNUNGEN = 1;

export const anzahlWohnungenReducer = function (
  sectionState: number = null,
  action: AnyAction,
): number {
  switch (action.type) {
    case PhActions.ANZAHL_WOHNUNGEN_CHANGED: {
      return action.payload;
    }
    case PhActions.ZUSATZOPTION_UNCHECKED: {
      const zusatzOptionName = action.payload.name;
      if (zusatzOptionName === WOHNUNGSHAFTPFLICHT_NAME) {
        return DEFAULT_ANZAHL_WOHNUNGEN;
      } else {
        return sectionState;
      }
    }
    case GlobalActions.VORBELEGUNG_FOR_BEIBEHALTUNG_REQUESTED: {
      const actionPayload: PhVorbelegungdaten = action.payload;
      if (actionPayload.forApp === App.PH) {
        return actionPayload.anzWohnungen;
      }
      return sectionState;
    }
    case PhActions.PRODUKT_DATEN_VORBELEGT: {
      const relevantVorbelegungdaten: PhVorbelegungdaten = action.payload;
      return relevantVorbelegungdaten?.anzWohnungen
        ? relevantVorbelegungdaten.anzWohnungen
        : DEFAULT_ANZAHL_WOHNUNGEN;
    }
    default:
      return sectionState;
  }
};
